import React, { useEffect } from 'react';
import { COLORS, TYPOGRAPHY } from '../../lib/styleGuide';
import { useAuth } from '../../contexts/AuthContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const ACCENT_GRAY = '#757575';
const headingFont = { fontFamily: 'Sora, sans-serif', fontWeight: 400 };
const bodyFont = { fontFamily: 'Montserrat, sans-serif', fontWeight: 500 };
const buttonFont = { fontFamily: 'Montserrat, sans-serif', fontWeight: 700 };
const stepCircleShadow = '0 4px 12px rgba(0,0,0,0.18)';

export default function WelcomeStep({ onNext }) {
  const { user } = useAuth();

  useEffect(() => {
    const updateOnboardingStatus = async () => {
      if (user) {
        const userRef = doc(db, 'users', user.uid);
        await updateDoc(userRef, {
          onboardingStarted: true,
        });
      }
    };

    updateOnboardingStatus();
  }, [user]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      <div style={{ maxWidth: 400, width: '100%', margin: '0 auto', textAlign: 'left' }}>
        <h2 style={{ 
          fontSize: TYPOGRAPHY.ONBOARDING.H2, 
          background: COLORS.PRIMARY_GRADIENT,
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          margin: '32px 0 8px 0', 
          lineHeight: 1.1, 
          ...headingFont 
        }}>Simple as 1, 2, 3</h2>
        <p style={{ fontSize: TYPOGRAPHY.ONBOARDING.SUBTITLE, color: '#222', margin: '0 0 32px 0', ...bodyFont }}>
          Bring your delicious food to hungry bellies near you.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
          {/* Step 1 */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18 }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: COLORS.PRIMARY_GRADIENT, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: TYPOGRAPHY.ONBOARDING.STEP_NUMBER, flexShrink: 0, ...bodyFont, boxShadow: stepCircleShadow }}>1</div>
            <div>
              <div style={{ 
                background: COLORS.PRIMARY_GRADIENT,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: TYPOGRAPHY.ONBOARDING.STEP_HEADING, 
                marginBottom: 2, 
                fontWeight: 700, 
                fontFamily: 'Sora, sans-serif' 
              }}>Tell us about your shop</div>
              <div style={{ color: ACCENT_GRAY, fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, lineHeight: 1.4, ...bodyFont }}>
                Share some details about your shop, it's location, and what you'd like to name it
              </div>
            </div>
          </div>
          {/* Step 2 */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18 }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: COLORS.PRIMARY_GRADIENT, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: TYPOGRAPHY.ONBOARDING.STEP_NUMBER, flexShrink: 0, ...bodyFont, boxShadow: stepCircleShadow }}>2</div>
            <div>
              <div style={{ 
                background: COLORS.PRIMARY_GRADIENT,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: TYPOGRAPHY.ONBOARDING.STEP_HEADING, 
                marginBottom: 2, 
                fontWeight: 700, 
                fontFamily: 'Sora, sans-serif' 
              }}>Open your shop</div>
              <div style={{ color: ACCENT_GRAY, fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, lineHeight: 1.4, ...bodyFont }}>
                Pay a one-time $10 fee that will help us continue to help cooks and bakers like you.
              </div>
            </div>
          </div>
          {/* Step 3 */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18 }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: COLORS.PRIMARY_GRADIENT, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: TYPOGRAPHY.ONBOARDING.STEP_NUMBER, flexShrink: 0, ...bodyFont, boxShadow: stepCircleShadow }}>3</div>
            <div>
              <div style={{ 
                background: COLORS.PRIMARY_GRADIENT,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: TYPOGRAPHY.ONBOARDING.STEP_HEADING, 
                marginBottom: 2, 
                fontWeight: 700, 
                fontFamily: 'Sora, sans-serif' 
              }}>Create your first product</div>
              <div style={{ color: ACCENT_GRAY, fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, lineHeight: 1.4, ...bodyFont }}>
                Roll up your sleeves and get cooking and baking. You've got hungry mouths to feed.
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={() => onNext && onNext()}
          style={{
            marginTop: 48,
            width: '100%',
            background: COLORS.PRIMARY_GRADIENT,
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            padding: '14px 0',
            fontSize: TYPOGRAPHY.ONBOARDING.BUTTON_TEXT,
            cursor: 'pointer',
            boxShadow: '0 2px 8px #0002',
            letterSpacing: 1,
            transition: 'all 0.2s',
            ...buttonFont,
          }}
          aria-label="Set-Up Shop"
        >
          SET-UP SHOP
        </button>
      </div>
    </div>
  );
} 